/* Copyright (c) 2020-present CloudIO Inc */

import { Grid, Typography, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Icon from 'icons/Icon';
import React from 'react';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    background: theme.palette.background.default,
    color: theme.palette.text.disabled,
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
  },
  h: {
    fontWeight: 700,
  },
  desc: {},
  icon: {
    marginTop: 20,
    color: theme.palette.text.disabled,
  },
}));

export default function NotFound({
  code = 404,
  reason,
}: {
  code?: number;
  reason: string;
}): React.ReactElement {
  const classes = useStyles();
  return (
    <Grid
      className={classes.root}
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Typography className={classes.h} variant="h1">
        {code}!
      </Typography>
      <Typography
        className={classes.desc}
        variant="subtitle1"
        color="textSecondary"
      >
        This is not the page you are looking for!
      </Typography>
      <Typography
        className={classes.desc}
        variant="subtitle1"
        color="textSecondary"
      >
        {reason}
      </Typography>
      <Link to="/">
        <Icon
          width={40}
          height={40}
          className={classes.icon}
          iconName="home"
          color="ioGrey"
        />
      </Link>
    </Grid>
  );
}
